import _ from "lodash";

function parseToUppercase(item: any) {
  for (const key in item) {
    if (typeof item[key] === "string") item[key] = item[key].toUpperCase();
  }
  return item;
}

const wordMappings = {
  street: "st",
  avenue: "ave",
  STREET: "ST",
  AVENUE: "AVE",
};

const normalizeWord = (word: string): string => {
  return wordMappings[word.toUpperCase()] || word;
};

const normalizeInput = (input: string): string => {
  return input
    .split(/\s+/) // Split by whitespace
    .map((word) => normalizeWord(word)) // Normalize each word
    .join(" "); // Rejoin into a single string
};

const isDifferent = (a: string, b: string): boolean => {
  if (!a || !b) return false;

  const normalizedA = normalizeInput(a.trim());
  const normalizedB = normalizeInput(b.trim());
  return normalizedA !== normalizedB;
};

const isIncluded = (a: string, b: string): boolean => {
  if (!a || !b) return false;

  const normalizedA = normalizeInput(a.trim());
  const normalizedB = normalizeInput(b.trim());

  return normalizedA.includes(normalizedB) || normalizedB.includes(normalizedA);
};

const isPostalCodeExtended = (
  updatedPostalCode: string,
  postalCode: string
): boolean => {
  if (!updatedPostalCode || !postalCode) return false;

  const updatedPostalCodeNoSpaces = updatedPostalCode.replace(/\s/g, "");
  const postalCodeNoSpaces = postalCode.replace(/\s/g, "");

  return updatedPostalCodeNoSpaces.startsWith(postalCodeNoSpaces);
};

export default function (updatedDetailNoParsed, stageDetailNoParsed): boolean {
  if (!updatedDetailNoParsed || !stageDetailNoParsed) return false;

  const updatedDetail: any = parseToUppercase(
    _.cloneDeep(updatedDetailNoParsed)
  );
  const stageDetail: any = parseToUppercase(_.cloneDeep(stageDetailNoParsed));
  return (
    isDifferent(updatedDetail?.company, stageDetail?.company) ||
    !isIncluded(updatedDetail?.streetAddress, stageDetail?.streetAddress) ||
    isDifferent(updatedDetail?.address2, stageDetail?.address2) ||
    isDifferent(updatedDetail?.city, stageDetail?.city) ||
    isDifferent(
      updatedDetail.state?.stateprovcode,
      stageDetail.state?.stateprovcode
    ) ||
    !isPostalCodeExtended(updatedDetail.postalCode, stageDetail.postalCode) ||
    isDifferent(updatedDetail.country?.code, stageDetail.country?.code)
  );
}
